module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "EditableGridCell",
    class: {
      'active': _vm.isActive,
      'is-editable': _vm.isEditable,
      'has-danger': _vm.hasDanger,
      'has-padding': _vm.hasPadding
    }
  }, [_c('a', {
    ref: "cell",
    class: {
      'not-being-edited': !_vm.isBeingEdited || !_vm.isActive
    },
    attrs: {
      "href": "#"
    },
    on: {
      "focus": _vm.activate,
      "click": function($event) {
        $event.preventDefault();
      },
      "dblclick": function($event) {
        $event.preventDefault();
        _vm.toggleEdit($event)
      },
      "keydown": function($event) {
        $event.stopPropagation();
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.toggleEdit($event)
      }
    }
  }, [(_vm.isEditable && _vm.isBeingEdited && _vm.isActive) ? _vm._t("edit") : _vm._t("view"), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-29a96a2f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditableGridCell.vue
// module id = 1675
// module chunks = 1